/* One-tap quick add for product cards. Delegated so re-rendered cards keep working.
   Adds via the Cart AJAX API, then shows the "Added" bar (View cart / Check out) and
   refreshes every cart count on the page from /cart.js.
   Also exposes window.L3DCart (count sync) and window.L3DAddedBar for other add buttons
   (the O1 hub's own "+ Add to cart"), and resyncs counts when Back restores a page. */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- cart counts (header bubble + menu "View cart (N)") ---------- */
  function bumpCount() {
    var count = document.querySelector('#cart-icon-bubble .l3d-hdr__cart-count');
    if (count) {
      count.classList.remove('l3d-qa-bump');
      void count.offsetWidth;
      count.classList.add('l3d-qa-bump');
    }
  }

  function syncCounts(cart, bump) {
    if (!cart) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var count = bubble.querySelector('.l3d-hdr__cart-count');
      if (cart.item_count > 0) {
        if (!count) {
          count = document.createElement('span');
          count.className = 'l3d-hdr__cart-count';
          count.setAttribute('aria-hidden', 'true');
          bubble.appendChild(count);
        }
        count.textContent = cart.item_count;
      } else if (count) {
        count.remove();
      }
    }
    document.querySelectorAll('[data-l3d-cart-n]').forEach(function (el) { el.textContent = cart.item_count; });
    if (bump) bumpCount();
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function refresh(bump) {
    return getCart().then(function (cart) { syncCounts(cart, bump); return cart; }).catch(function () { return null; });
  }

  /* Back/Forward can show old HTML (from the back/forward cache, or the browser's page cache):
     the cart page reloads, other pages just resync their counts. */
  function cameBack(e) {
    if (e.persisted) return true;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return !!(nav && nav.type === 'back_forward');
    } catch (err) { return false; }
  }
  window.addEventListener('pageshow', function (e) {
    if (!cameBack(e)) return;
    var path = location.pathname.replace(/\/$/, '');
    if (/\/cart$/.test(path)) {
      // Reload the cart page only when what it shows is out of date (a reload is not back/forward, so no loop).
      if (e.persisted) { location.reload(); return; }
      var shown = document.querySelector('#cart-icon-bubble .l3d-hdr__cart-count');
      var shownCount = shown ? parseInt(shown.textContent, 10) || 0 : 0;
      getCart().then(function (cart) { if (cart.item_count !== shownCount) location.reload(); }).catch(function () {});
      return;
    }
    refresh(false);
  });

  // Keep the menu count right after cart page edits (Dawn publishes cart updates).
  document.addEventListener('DOMContentLoaded', function () {
    // PUB_SUB_EVENTS is a top-level const in constants.js, so it is not on window.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
        // Use the cart state Dawn sends, so rapid edits cannot leave an older count showing.
        if (e && e.cartData && typeof e.cartData.item_count === 'number') syncCounts(e.cartData, false);
        else refresh(false);
      });
    }
  });

  /* ---------- the "Added" bar ---------- */
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  var barTimer = null;
  function hideBar() {
    var bar = document.getElementById('l3d-added');
    if (!bar) return;
    bar.classList.remove('is-open');
    clearTimeout(barTimer);
  }

  function showBar(opts) {
    var bar = document.getElementById('l3d-added');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'l3d-added';
      bar.className = 'l3d-added';
      bar.setAttribute('role', 'status');
      bar.setAttribute('aria-live', 'polite');
      document.body.appendChild(bar);
      bar.addEventListener('click', function (e) { if (e.target.closest('.l3d-added__x')) hideBar(); });
      // Pause the auto-close while a finger or focus is on the bar, then restart it.
      bar.addEventListener('pointerenter', function () { clearTimeout(barTimer); });
      bar.addEventListener('focusin', function () { clearTimeout(barTimer); });
      var restart = function () { if (!bar.classList.contains('is-open')) return; clearTimeout(barTimer); barTimer = setTimeout(hideBar, 5000); };
      bar.addEventListener('pointerleave', restart);
      bar.addEventListener('pointerup', restart);
      bar.addEventListener('focusout', restart);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideBar(); });
    }
    var esc = function (s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
    var html;
    if (opts.error) {
      bar.classList.add('is-error');
      html = '<div class="l3d-added__row"><span class="l3d-added__icon" aria-hidden="true">!</span>' +
        '<div class="l3d-added__txt"><strong>That did not go into your cart</strong><span>' + esc(opts.message || 'Check your connection and try again.') + '</span></div>' +
        '<button type="button" class="l3d-added__x" aria-label="Close">&times;</button></div>';
    } else {
      bar.classList.remove('is-error');
      var cart = opts.cart;
      var meta = cart ? 'Cart: ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items') + ' &middot; ' + esc(money(cart.total_price, cart.currency)) : '';
      html = '<div class="l3d-added__row"><span class="l3d-added__icon" aria-hidden="true">&#10003;</span>' +
        '<div class="l3d-added__txt"><strong>Added to your cart</strong>' +
        (opts.title ? '<span class="l3d-added__title">' + esc(opts.title) + '</span>' : '') +
        (meta ? '<span class="l3d-added__meta">' + meta + '</span>' : '') + '</div>' +
        '<button type="button" class="l3d-added__x" aria-label="Close">&times;</button></div>' +
        '<div class="l3d-added__actions"><a class="l3d-added__view" href="' + root + 'cart">View cart</a>' +
        '<a class="l3d-added__go" href="' + root + 'checkout">Check out</a></div>';
    }
    bar.innerHTML = html;
    void bar.offsetWidth;
    bar.classList.add('is-open');
    clearTimeout(barTimer);
    barTimer = setTimeout(hideBar, opts.error ? 6000 : 8000);
  }

  // Opening the phone menu closes the Added bar so it never covers the menu.
  document.addEventListener('DOMContentLoaded', function () {
    var hdr = document.getElementById('l3d-header');
    if (!hdr || !('MutationObserver' in window)) return;
    new MutationObserver(function () { if (hdr.classList.contains('l3d-hdr--open')) hideBar(); })
      .observe(hdr, { attributes: true, attributeFilter: ['class'] });
  });

  window.L3DCart = { refresh: refresh, sync: syncCounts };
  window.L3DAddedBar = { show: showBar, hide: hideBar };

  /* Session flag for the STL acknowledgement (digital waiver + printer size).
     sessionStorage can throw in some privacy modes; fall back to an in-memory flag. */
  var stlAckMemory = false;
  function stlAckGiven() {
    if (stlAckMemory) return true;
    try { return sessionStorage.getItem('l3dStlAck') === '1'; } catch (err) { return false; }
  }
  function setStlAck() {
    stlAckMemory = true;
    try { sessionStorage.setItem('l3dStlAck', '1'); } catch (err) {}
  }

  function openStlAckModal(btn) {
    var existing = document.querySelector('.l3d-qa-modal');
    if (existing) existing.remove();
    var overlay = document.createElement('div');
    overlay.className = 'l3d-qa-modal';
    overlay.innerHTML =
      '<div class="l3d-qa-modal__box" role="dialog" aria-modal="true" aria-label="Before these files go in your cart">' +
        '<p class="l3d-qa-modal__title">Quick check before these files go in your cart</p>' +
        '<ul class="l3d-qa-modal__list">' +
          '<li>These are <strong>instant digital downloads</strong>. Nothing physical is posted. Files are supplied immediately after checkout and I agree that I lose my 14 day right to cancel once delivery begins, so <strong>digital files are non-refundable</strong>. This does not affect my rights if a file is faulty.</li>' +
          '<li>Every jig comes two ways: <strong>one piece</strong> for large printers, or <strong>split into two halves</strong> that print on any machine. Each half is <strong>155 x 125mm</strong> (about 6 x 5 inches), which fits a Bambu A1 mini and just about anything bigger.</li>' +
        '</ul>' +
        '<label class="l3d-qa-modal__ack"><input type="checkbox" class="l3d-qa-modal__tick"> I understand and agree</label>' +
        '<div class="l3d-qa-modal__actions">' +
          '<button type="button" class="l3d-qa-modal__cancel">Cancel</button>' +
          '<button type="button" class="l3d-qa-modal__confirm" disabled>Add to cart</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    var tick = overlay.querySelector('.l3d-qa-modal__tick');
    var confirm = overlay.querySelector('.l3d-qa-modal__confirm');
    var cancel = overlay.querySelector('.l3d-qa-modal__cancel');
    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(ev) { if (ev.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);
    overlay.addEventListener('click', function (ev) { if (ev.target === overlay) close(); });
    cancel.addEventListener('click', close);
    tick.addEventListener('change', function () { confirm.disabled = !tick.checked; });
    confirm.addEventListener('click', function () {
      if (!tick.checked) return;
      setStlAck();
      close();
      doAdd(btn);
    });
    tick.focus();
  }

  function announce(text) {
    var live = document.getElementById('l3d-qa-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'l3d-qa-live';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  function doAdd(btn) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-busy');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [btn.dataset.l3dQaAck
          ? { id: parseInt(btn.dataset.variantId, 10), quantity: 1, properties: { '_Digital waiver agreed': 'Yes, in the quick add check, ' + new Date().toISOString().slice(0, 10) } }
          : { id: parseInt(btn.dataset.variantId, 10), quantity: 1 }]
      })
    })
      .then(function (res) {
        // A bot-check page is HTML, not JSON: treat it as a failed add. A 422 (sold out, limit) carries its own message.
        return res.text().then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (err) {}
          if (res.ok && data) return data;
          var e = new Error('add failed');
          if (data && res.status === 422) e.userMessage = data.description || data.message;
          throw e;
        });
      })
      .then(function () {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        announce('Added to cart');
        return refresh(true).then(function (cart) {
          showBar({ title: btn.dataset.title, cart: cart });
        });
      })
      .catch(function (err) {
        btn.classList.add('is-error');
        announce((err && err.userMessage) || 'Could not add to cart. Please try again.');
        showBar({ error: true, message: err && err.userMessage });
        setTimeout(function () { btn.classList.remove('is-error'); }, 4000);
      })
      .then(function () { btn.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-l3d-qa]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.l3dQaAck && !stlAckGiven()) {
      openStlAckModal(btn);
      return;
    }
    doAdd(btn);
  });
})();
